// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"74512667","374":"ac6b1efe","453":"a6d97cee","508":"26dc0531"}[chunkId] + ".chunk.js";
};